import ClipboardNotification from "./ClipboardNotification";

export default ClipboardNotification;